
import {Vue, Component} from 'vue-property-decorator';
import SelectMechanism from "@/components/SelectMechanism.vue";
import ckeditor from "@/components/AllCkeditorComponent.vue";
import {noticeApi} from "@/api/notice.ts";

@Component({
  components: {
    ckeditor,SelectMechanism
  }
})
export default class Order extends Vue {
  private saveShow = true;
  private organizations = [];// 列表
  private showQuery = false;
  private showInfoDialog = false;
  private listEdit = false;
  private queryParams = {
    title: '',
    current: 1,
    size: 10,
    total: 0
  }

  private orgInfoDefault = {
    title: '',
    content: ''
  }

  private orgInfo = Object.assign({}, this.orgInfoDefault);

  mounted() {
    // 加载列表
    this.loadData();
    this.haveRight();
  }

  loadData(){
    this.tableClearSelect();
    noticeApi.pageList(this.queryParams).then((r: any) => {
      const res = r.data;
      if(res.result === 0){
        this.queryParams.total = res.data.total;
        this.organizations = res.data.records;
      }
    });

  }
  reset(){
    this.queryParams.title='';
    this.loadData();
  }

  onAdd(){
    this.orgInfo = Object.assign({}, this.orgInfoDefault);
    this.showInfoDialog = true;
  }

  onEdit(){
    if(!this.isCheckedOne()){
      return;
    }

    const item = this.selectedItems[0] as any;
    noticeApi.getDetail({
      id: item.id
    }).then((r: any) => {
      const res = r.data;
      if(res.result === 0){
        this.orgInfo = Object.assign({}, this.orgInfoDefault, res.data);
        this.showInfoDialog = true;
      }
    })
  }

  detailObj = {
    dialog: false,
    data: {} as any
  }
  onToDetail(row :any){
    this.detailObj.data = Object.assign({}, this.orgInfoDefault, row);
    this.detailObj.dialog = true;
    // this.saveShow = false;
    // this.orgInfo = Object.assign({}, this.orgInfoDefault, row);
    // this.showInfoDialog = true;
  }
  onClose() {
    this.saveShow=true;
    this.orgInfo = Object.assign({}, this.orgInfoDefault);
    let form = this.$refs.form as HTMLFormElement;
    form.resetFields();
    this.showInfoDialog = false;
  }
  onSave(){
    let form = this.$refs.form as HTMLFormElement;
    form.validate((valid: any) => {
      if (valid) {
        noticeApi.addOrUpdate(this.orgInfo).then((r: any) => {
          const res = r.data;
          if(res.result === 0){
            this.$message.success("保存成功")
            this.showInfoDialog = false;
            this.loadData();
            this.onClose();
          }
        });
      }
    });
  }
  onDelete(){
    if(!this.isChecked()){
      return;
    }
    this.$confirm("确实要删除选中的数据吗?", "确认操作").then(() => {
      noticeApi.delete({ids: this.selectedItems.map((i: any) => i.id).join(",")}).then((r: any) => {
        if(r.data.result === 0){
          this.loadData();
        }
      });
    })
  }

  isCheckedOne(){
    if(this.isChecked()){
      if(this.selectedItems.length !== 1){
        this.$message.error("请先选择一条记录");
        return false;
      }
    }

    return true;
  }

  isChecked(){
    if(!this.selectedItems || this.selectedItems.length === 0){
      this.$message.error("请先选择一条记录");
      return false;
    }
    return true;
  }

  private selectedItems = [];
  onSelectItem(selection: any, row: any) {
    this.selectedItems = selection;
  }
  tableClearSelect() {
    this.selectedItems = [];
    let $table = this.$refs.table as HTMLFormElement;
    if ($table) {
      $table.clearSelection();
    }
  }
  pageSizeChange(val: number) {
    this.queryParams.size = val;
    this.loadData();
  }
  pageCurrentChange(val: number) {
    this.queryParams.current = val;
    this.loadData();
  }
  indexMethod(index: any) {
    return (this.queryParams.current-1)*this.queryParams.size+index+1;
  }
  private rules = {
    title: [{required: true, message: '请输入标题', trigger: 'blur'}],
    content: [{required: true, message: '请输入内容', trigger: 'blur'}],
  }
  haveRight(){
    const right = this.$store.state.userRights;
    right.forEach((e:any)=>{
      if(e.name == "cxjl_notice_edit"){
        this.listEdit = true;
      }
    })
  }
}
